import { Dispatch, SetStateAction } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { Dialog, DialogProps, DialogTitle, Divider, IconButton } from '@mui/material'

import useStyles from './index.styles'

interface IProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  title: string
  children: React.ReactNode[] | React.ReactNode
}

const DialogWithTitle = (props: IProps & DialogProps) => {
  const { open, setOpen, title, children, ...rest } = props

  const classes = useStyles

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="sm"
      sx={{ overflowY: 'auto' }}
      {...rest}
    >
      <DialogTitle sx={classes.dialogTitle}>
        {title}
        <IconButton sx={classes.closeIcon} onClick={() => setOpen(false)} data-testid="close-modal-btn" aria-label="Close dialog">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider sx={classes.divider} />

      {children}
    </Dialog>
  )
}

export default DialogWithTitle
